import React, { useState, useEffect } from 'react';
import { PieChart, Pie, Cell, Label } from 'recharts';
import Slider from "react-slick";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import axios from 'axios'; // Assuming you're using axios for fetching data

// Mock function to simulate fetching subjects from an API
const fetchSubjects = async () => {
    // Replace with your API call to fetch subjects
    const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/course/get-all-course-ids`);
    return response.data; 
};

const COLORS = [
    ['#0088FE', '#f7f7f7'],
    ['#FFBB28', '#f7f7f7'],
    ['#FF6384', '#f7f7f7'],
    ['#4BC0C0', '#f7f7f7'],
    ['#9966FF', '#f7f7f7'],
    ['#66FF66', '#f7f7f7'],
    ['#66FF66', '#f7f7f7'],
    ['#66FF66', '#f7f7f7'],
];

const subjects = [
    { name: 'FDFED', attended: 25, unattended: 5 },
    { name: 'ICS', attended: 22, unattended: 8 },
    { name: 'BTA', attended: 27, unattended: 3 },
    { name: 'NLP', attended: 28, unattended: 2 },
    { name: 'CGM', attended: 20, unattended: 10 },
    { name: 'IDA', attended: 18, unattended: 12 },
];

const AttendanceChart = () => {
    let [subjects, setSubjects] = useState([]); // State for subjects
    const [loading, setLoading] = useState(true); // State to handle loading state
     subjects = [
        { name: 'FDFED', attended: 25, unattended: 5 },
        { name: 'ICS', attended: 22, unattended: 8 },
        { name: 'BTA', attended: 27, unattended: 3 },
        { name: 'NLP', attended: 28, unattended: 2 },
        { name: 'CGM', attended: 20, unattended: 10 },
        { name: 'IDA', attended: 18, unattended: 12 },
    ];
    useEffect(() => {
        const fetchData = async () => {
            try {
                const subjectsData = await fetchSubjects();
                console.log('Fetched subjects:', subjectsData);
                setSubjects(subjectsData); // Set the fetched subjects
            } catch (error) {
                console.error('Error fetching subjects:', error);
            } finally {
                setLoading(false); // Set loading to false once data is fetched
            }
        };

        fetchData();
    }, []);

    // Render Pie chart for each subject
    const renderPieChart = (subject, index) => (
        <div key={index} style={styles.chartContainer}>
            <PieChart width={200} height={200}>
                <Pie
                    data={[
                        { name: 'Attended', value: subject.attended },
                        { name: 'Unattended', value: subject.unattended },
                    ]}
                    cx={100}
                    cy={100}
                    innerRadius={60}
                    outerRadius={80}
                    fill="#8884d8"
                    paddingAngle={5}
                    dataKey="value"
                >
                    {[
                        { name: 'Attended', value: subject.attended },
                        { name: 'Unattended', value: subject.unattended },
                    ].map((entry, idx) => (
                        <Cell key={`cell-${idx}`} fill={COLORS[index][idx % COLORS[index].length]} />
                    ))}
                    <Label
                        value={`Attended: ${subject.attended}`}
                        position="center"
                        style={{ fontSize: '14px', fill: '#000' }}
                    />
                </Pie>
            </PieChart>
            <p style={styles.subjectLabel}>{subject.name}</p> {/* Subject label */}
        </div>
    );

    // Slick slider settings
    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 3, // Show 3 charts at once
        slidesToScroll: 3,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1, // Show 1 chart at once for small screens
                    slidesToScroll: 1,
                },
            },
        ],
    };

    if (loading) {
        return <div>Loading...</div>; // Show loading while data is being fetched
    }

    return (
        <div style={styles.card}>
            <Slider {...settings}>
                {subjects.map((subject, index) => renderPieChart(subject, index))}
            </Slider>
        </div>
    );
};

// Simple card styles
const styles = {
    card: {
        width: '100%',
        height: '100%',
        padding: '1rem',
        color: "#ffffff",
    },
    chartContainer: {
        textAlign: 'center',
        padding: '0 1rem',
    },
    subjectLabel: {
        margin: '10px 0',
        fontSize: '1.1em',
        color: '#333',
        textAlign: 'center',
    },
};

export default AttendanceChart;
